// 履歴一覧: 子どもの反応ログ（DB対応版）
import { useState } from 'react';
import { ReactionLog, ReactionVerdict } from '../types';
import { useReactions } from '../hooks/useReactions';

const VERDICT_LABEL: Record<ReactionVerdict, string> = {
  positive: '✅ 肯定',
  negative: '🚫 拒否',
  ambiguous: '❓ 曖昧',
  silent: '🔇 無音',
};

const VERDICT_CLASS: Record<ReactionVerdict, string> = {
  positive: 'verdict-positive',
  negative: 'verdict-negative',
  ambiguous: 'verdict-ambiguous',
  silent: 'verdict-silent',
};

type Filter = 'all' | 'week';

export default function History() {
  const [filter, setFilter] = useState<Filter>('week');
  const { reactions, loading, clearAll } = useReactions(500);

  const filtered = filterHistory(reactions, filter);

  const handleClear = async () => {
    if (!confirm('履歴をすべて削除しますか？（戻せません）')) return;
    await clearAll();
  };

  return (
    <>
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <h2 style={{ margin: 0 }}>応答履歴（{filtered.length}件）</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              className={`btn btn-sm ${filter === 'week' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter('week')}
            >
              直近7日
            </button>
            <button
              className={`btn btn-sm ${filter === 'all' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter('all')}
            >
              全期間
            </button>
            <button className="btn btn-sm btn-danger" onClick={handleClear}>
              全削除
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="card">
          <p className="muted">読み込み中...</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="card">
          <p className="muted">まだ履歴がありません。タスクが発火すると、ここに記録されます。</p>
        </div>
      ) : (
        <div>
          {filtered.map((log) => (
            <div key={log.id} className="history-item">
              <div className="head">
                <span>
                  <strong>{log.level.toUpperCase()}</strong> / {log.taskTitle} / {formatTime(log.firedAt)}
                </span>
                {log.verdict && (
                  <span className={VERDICT_CLASS[log.verdict]}>{VERDICT_LABEL[log.verdict]}</span>
                )}
              </div>
              <div className="body">📢 {log.announcement}</div>
              {log.reply !== undefined && (
                <div className="reply">
                  🗣️ 子ども: {log.reply || <span className="muted">（無音 / 15秒以内に応答なし）</span>}
                </div>
              )}
              {typeof log.ignoreCount === 'number' && log.ignoreCount >= 3 && (
                <div className="alert" style={{ marginTop: 6 }}>
                  ⚠️ 無視カウント {log.ignoreCount} 回（要注意）
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}

function filterHistory(history: ReactionLog[], filter: Filter): ReactionLog[] {
  if (filter === 'all') return history;
  const cutoff = Date.now() - 7 * 24 * 60 * 60 * 1000;
  return history.filter((h) => h.firedAt >= cutoff);
}

function formatTime(ms: number): string {
  const d = new Date(ms);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getMonth() + 1}/${d.getDate()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
